import React from "react";
import ReactDOM, {createRoot} from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App"
import "./styles/styles.css";

const root = createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  // </React.StrictMode>
);
